import { useScaffold } from "@Light/scaffold";
import { Item } from "./Item";

export type BrokerTermsOfServiceProps = {};
export const BrokerTermsOfService: React.FC<
  BrokerTermsOfServiceProps
> = ({}) => {
  const scaffold = useScaffold();
  const { termsOfServiceUrl } = scaffold.page;
  if (!termsOfServiceUrl) {
    return null;
  }
  return <Item title="Broker Terms of Service" href={termsOfServiceUrl} />;
};
